import '@/config/config.axios';

import { plugin as formkitPlugin } from '@formkit/vue';

import { createApp } from 'vue';

import FormKitOptions from '@/config/config.formkit';
import TheDefaultLayout from '@/components/Layout/TheDefaultLayout.vue';
import ThePlainLayout from '@/components/Layout/ThePlainLayout.vue';
import TheFilterLayout from '@/components/Layout/TheFilterLayout.vue';
import TheThankYouLayout from '@/components/Layout/TheThankYouLayout.vue';
import i18n from '@/config/config.i18n.js';

import App from '@/App.vue';
import bootstrapRouter from './router';

import '@/styles/styles.scss';
import 'bootstrap';

import baseComponentsLoader from '@/config/config.baseComponentsLoader.js';
import { sentryInit } from '@/config/config.sentry.js';
import configPinia from '@/config/config.pinia.js';

const app = createApp(App);

// Layouts global
app.component('TheDefaultLayout', TheDefaultLayout);
app.component('ThePlainLayout', ThePlainLayout);
app.component('TheFilterLayout', TheFilterLayout);
app.component('TheThankYouLayout', TheThankYouLayout);

// Base components global
baseComponentsLoader(app);

// State management with Pinia.
app.use(configPinia());

app.use(formkitPlugin, FormKitOptions);
app.use(i18n());

// Get the routes for the selected funnel
bootstrapRouter().then((router) => {
  app.use(router);

  // Sentry implementation (production only)
  if (import.meta.env.VITE_SENTRY_ENV === 'production') {
    sentryInit(app, router);
  }

  app.mount('#app');
});
